import { render, staticRenderFns } from "./Ipaid.vue?vue&type=template&id=a086789a&scoped=true&"
import script from "./Ipaid.vue?vue&type=script&lang=js&"
export * from "./Ipaid.vue?vue&type=script&lang=js&"
import style0 from "./Ipaid.vue?vue&type=style&index=0&id=a086789a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a086789a",
  null
  
)

export default component.exports